<template>
  <div>
    <span 
      v-if="!!(label || '').length"
      class="caption font-weight-light"
    >
      {{ label }}
    </span>
    <div class="d-flex">
      <v-btn
        icon
        :disabled="valueIndex === 0"
        @click="$emit('input', (options[valueIndex - 1] || options[0])[itemValue])"
      >
        <v-icon :color="decreaseColor">
          mdi-minus
        </v-icon>
      </v-btn>
      <v-fade-transition
        hide-on-leave
        group
        class="d-flex align-self-center"
      >
        <template v-for="(option, index) of options">
          <div 
            v-if="valueIndex === index"
            :key="`${option[itemValue]}-${index}`"
            class="px-5"
          >
            <!-- Slots are base-1 in name -->
            <slot 
              :name="`option-${index + 1}-content`"
              :option="option"
              :index="index"
            >
              <v-icon
                large
                :color="option.color || 'black'"
              >
                {{ option[itemIcon] }}
              </v-icon>
            </slot>
          </div>
        </template>
      </v-fade-transition>
      <v-btn
        icon
        :disabled="valueIndex === options.length - 1"
        @click="$emit('input', (options[valueIndex + 1] || options[options.length - 1])[itemValue])"
      >
        <v-icon :color="increaseColor">
          mdi-plus
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinearSelect',
  props: {
    value: [String, Number],
    options: {
      type: Array,
      required: true
    },
    itemIcon: {
      type: String,
      default: 'icon'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    decreaseIcon: {
      type: String,
      default: 'mdi-minus'
    },
    decreaseColor: {
      type: String,
      default: 'black'
    },
    increaseIcon: {
      type: String,
      default: 'mdi-plus'
    },
    increaseColor: {
      type: String,
      default: 'black'
    },
    label: String,
  },
  data () {
    return {}
  },
  computed: {
    valueIndex () {
      const index = this.options.findIndex(e => e[this.itemValue] === this.value)
      if (index !== -1) return index
      return 0
    }
  }
}
</script>